import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getCity = (cityId: number | undefined): Promise<IGetCity> => {
  return axiosDefaultApi.get(`/api/Cities/GetCityViaID/${cityId}`);
};

type QueryFnType = typeof getCity;

type UseGetCityOptions = {
  cityId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetCity = ({ cityId , config }: UseGetCityOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getCity_${cityId}`],
    queryFn: () => getCity(cityId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Πόλης.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};